module.exports = __webpack_public_path__ + "assets/img/1553-sm.svg";